import {ChangeDetectorRef, Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {ActionPointsService} from "../../../../service/club-gigot/action-points.service";
import {
    AbstractControl,
    FormArray,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators
} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {ActionPointType} from "../../../../model/club-gigot/action-points/_enum/action-point.enum";
import {finalize} from "rxjs/operators";
import {
    DialogActionPointsData
} from "../../../../model/club-gigot/action-points/dialog/dialog-action-points-data.model";
import {
    ActionPointsDTO,
    ContinutyActionPointDTO,
    FidelityActionPointDTO,
    IndicationActionPointDTO,
    SaleActionPointDTO
} from "../../../../model/club-gigot/action-points/action-points-configuration.model";
import {SaveActionPointsDTO} from "../../../../model/club-gigot/action-points/save-action-point.model";
import {CampaignDTO} from "../../../../core/models/campaignDTO.model";
import {CampaignService} from "../../../../core/services/campaign.service";


@Component({
  selector: 'kt-dialog-new-action-point-category',
  templateUrl: './dialog-new-action-point-category.component.html',
  styleUrls: ['./dialog-new-action-point-category.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DialogNewActionPointCategoryComponent implements OnInit {

    public actionPointCategoryCreationForm : FormGroup;
    public indicationCategoryCreationForm: FormGroup;
    public loading$ : BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public campaigns : CampaignDTO[] = []
    public maxConsecutiveCampaigns: number = 20;
    public maxConsecutiveYears: number = 15;
    public maxExpirationCampaign: number = 40;
    public maxCampaignsToNet: number = 40;
    public maxMultiplication: number = 10;
    public actionPointType: ActionPointType;
    public ActionPointType = ActionPointType;

    public _isEditMode : boolean;

    constructor(
        private dialogRef: MatDialogRef<DialogNewActionPointCategoryComponent>,
        private actionPointsService : ActionPointsService,
        private campaignService: CampaignService,
        private cdr: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogActionPointsData,
    ) {}

    public ngOnInit() : void {
        this.loadCampaigns();
        this.buildForm();
    }

    public buildForm() : void {
        this.actionPointType = this.data.actionPointType
        let actionPointData = this.data.actionPointData;
        this._isEditMode = actionPointData.length > 0;
        if(this.actionPointType == ActionPointType.Indication){
            actionPointData =actionPointData.filter(indicator => (indicator as IndicationActionPointDTO).forReferrer == false);
        }
        this.actionPointCategoryCreationForm = new FormGroup({
            id : new FormControl((this._isEditMode && actionPointData.length > 0)  ? actionPointData[0].id : null),
            campaignSequence: new FormControl(this.data.campaignSequence),
            name: new FormControl((this._isEditMode && actionPointData.length > 0) ? actionPointData[0].name : (this.actionPointType == ActionPointType.Indication ? "Indicacion" : null), [Validators.required]),
            expirationPointsCampaign: new FormControl((this._isEditMode && actionPointData.length > 0)? (actionPointData[0].expirationPointsCampaignSequence - actionPointData[0].applicableCampaignSequence).toString() : null, [Validators.required]),
            points: new FormControl((this._isEditMode && actionPointData.length > 0) ? actionPointData[0].points : null, [Validators.required, Validators.min(1)]),
            reachId: new FormControl((this._isEditMode && actionPointData.length > 0) ? actionPointData[0].reachId : null),
            campaignsToNet : new FormControl((this._isEditMode && actionPointData.length > 0)? (actionPointData[0].campaignsToNet).toString() : null, [Validators.required])
        })
        if(this.actionPointType == ActionPointType.Continuity){
            let continuityData = actionPointData[0] as ContinutyActionPointDTO;
            this.actionPointCategoryCreationForm.addControl('consecutiveCampaigns',
                new FormControl(this._isEditMode ? continuityData.consecutiveCampaigns.toString() : null, [Validators.required]));
        }
        if(this.actionPointType == ActionPointType.Fidelity){
            let fidelityData = actionPointData[0] as FidelityActionPointDTO;
            this.actionPointCategoryCreationForm.addControl('periodRequirement', new FormArray([]))
            if(!this._isEditMode){
                this.addPeriodicRequirement()
            }else{
                this.addPeriodicRequirementsEdit(fidelityData);
            }
        }
        if(this.actionPointType == ActionPointType.Sale){
            let saleData = actionPointData[0] as SaleActionPointDTO;
            this.actionPointCategoryCreationForm.addControl('toSaleValueMin',
                new FormControl(this._isEditMode ? saleData.fromSaleValue : 0, [
                    Validators.required,
                    Validators.min(0)
                ]))
            this.actionPointCategoryCreationForm.addControl('toSaleValueMax',
            new FormControl(this._isEditMode ? saleData.toSaleValue : null, [
                Validators.required,
                (control: AbstractControl) => Validators.min(this.actionPointCategoryCreationForm.controls["toSaleValueMin"].value)(control),
            ]))

            this.actionPointCategoryCreationForm.addControl('multiplication',
                new FormControl(this._isEditMode ? saleData.multiplication : 1, [Validators.required]))
        }
        if(this.actionPointType == ActionPointType.Indication){
            let data = this.data.actionPointData.filter(indicator => (indicator as IndicationActionPointDTO).forReferrer );
            let isReferer = data.length > 0;
            let indicationData = isReferer? data[0] as IndicationActionPointDTO : undefined;
            data =  this.data.actionPointData.filter(indicator => !(indicator as IndicationActionPointDTO).forReferrer );
            let indicatorData = (data.length > 0)? data[0] as IndicationActionPointDTO: undefined;
            this.indicationCategoryCreationForm = new FormGroup({
                id : new FormControl((this._isEditMode && indicationData != undefined) ? indicationData.id : null),
                campaignSequence: new FormControl(this.data.campaignSequence),
                name: new FormControl( "Indicacion" , [Validators.required]),
                expirationPointsCampaign: new FormControl((this._isEditMode && indicationData != undefined) ? (indicationData.expirationPointsCampaignSequence - indicationData.applicableCampaignSequence).toString() : null, [Validators.required]),
                points: new FormControl((this._isEditMode && indicationData != undefined) ? indicationData.points : null, [Validators.required, Validators.min(1)]),
                reachId: new FormControl((this._isEditMode && indicationData != undefined) ? indicationData.reachId : null),
                minimumOrders: new FormControl((this._isEditMode && indicationData != undefined)? indicationData.minimumOrders: null, [Validators.required, Validators.min(1)]),
                campaignsToNet : new FormControl((this._isEditMode && indicationData != undefined)? indicationData.campaignsToNet.toString() : null, [Validators.required])
            })
          this.actionPointCategoryCreationForm.addControl('indicator',
              new FormControl( (this._isEditMode)? actionPointData.length > 0: true));
          this.actionPointCategoryCreationForm.addControl('minimumIndications',
              new FormControl((this._isEditMode && indicatorData != undefined )? indicatorData.minimumIndications : null, [Validators.required, Validators.min(1)]));
          this.actionPointCategoryCreationForm.addControl('minimumOrdersForReferrer',
            new FormControl((this._isEditMode && indicatorData != undefined )? indicatorData.minimumOrdersForReferrer : null, [Validators.required, Validators.min(1)]));
          this.indicationCategoryCreationForm.addControl('indicated',
              new FormControl((this._isEditMode && indicationData != undefined)));
          this.indicationCategoryCreationForm.addControl('forReferrer',
              new FormControl(true));
          this.toggleIndicated();
          this.toggleIndicator();
          this.actionPointCategoryCreationForm.setValidators([this.validateIndicator()])
        }
    }

    public onNoClick(): void {
        this.actionPointCategoryCreationForm.reset();
        this.dialogRef.close(true);
    }

    public onSaveActionPointCategory(): void {
        this.validateForm();
        this.loading$.next(true);
        let actionPointDTO = new ActionPointsDTO();
        if(this.actionPointType == ActionPointType.Indication){
            if(this.actionPointCategoryCreationForm.controls['indicator'].value)
                actionPointDTO.addActionPoint(this.data.actionPointType, this.actionPointCategoryCreationForm.value);
            if(this.indicationCategoryCreationForm.controls['indicated'].value)
                actionPointDTO.addActionPoint(this.data.actionPointType, this.indicationCategoryCreationForm.value)
        } else {
            actionPointDTO.addActionPoint(this.data.actionPointType, this.actionPointCategoryCreationForm.value);
        }
        const dto = new SaveActionPointsDTO(this.data.actionPointType, actionPointDTO);
        this.actionPointsService
            .saveActionPointConfiguration(this.data.campaignSequence, dto, this._isEditMode)
            .pipe(
                finalize(() => {
                    this.loading$.next(false)
                    this.dialogRef.close(true);
                })
            )
            .subscribe({
                next: (_ : any) => {},
                error: (error : Error) => console.log(error)
            })
    }

    public validateForm() : void {
        if (this.actionPointCategoryCreationForm.invalid) {
            Object.keys(this.actionPointCategoryCreationForm.controls).forEach((controlName) =>
                this.actionPointCategoryCreationForm.controls[controlName].markAsTouched()
            );
            return;
        }
    }

    public toggleIndicator(): void {
        if(this.actionPointCategoryCreationForm.controls['indicator'].value){
            this.enableIndicator();
        }else {
            this.disableIndicator();
        }
    }

    public disableIndicator(): void{
        this.actionPointCategoryCreationForm.controls['expirationPointsCampaign'].disable();
        this.actionPointCategoryCreationForm.controls['points'].disable();
        this.actionPointCategoryCreationForm.controls['campaignsToNet'].disable();
        this.actionPointCategoryCreationForm.controls['reachId'].disable();
        this.actionPointCategoryCreationForm.controls['minimumIndications'].disable();
        this.actionPointCategoryCreationForm.controls['minimumOrdersForReferrer'].disable();
    }

    public enableIndicator(): void {
        this.actionPointCategoryCreationForm.controls['expirationPointsCampaign'].enable();
        this.actionPointCategoryCreationForm.controls['points'].enable();
        this.actionPointCategoryCreationForm.controls['reachId'].enable();
        this.actionPointCategoryCreationForm.controls['campaignsToNet'].enable();
        this.actionPointCategoryCreationForm.controls['minimumIndications'].enable();
        this.actionPointCategoryCreationForm.controls['minimumOrdersForReferrer'].enable();
    }

    public toggleIndicated(): void {
        if(this.indicationCategoryCreationForm.controls['indicated'].value){
            this.enableIndicated();
        }else {
            this.disableIndicated();
        }
        this.actionPointCategoryCreationForm.updateValueAndValidity();
    }

    public disableIndicated(): void{
        this.indicationCategoryCreationForm.controls['expirationPointsCampaign'].disable();
        this.indicationCategoryCreationForm.controls['points'].disable();
        this.indicationCategoryCreationForm.controls['reachId'].disable();
        this.indicationCategoryCreationForm.controls['campaignsToNet'].disable();
        this.indicationCategoryCreationForm.controls['minimumOrders'].disable();
    }

    public enableIndicated(): void{
        this.indicationCategoryCreationForm.controls['expirationPointsCampaign'].enable();
        this.indicationCategoryCreationForm.controls['points'].enable();
        this.indicationCategoryCreationForm.controls['campaignsToNet'].enable();
        this.indicationCategoryCreationForm.controls['reachId'].enable();
        this.indicationCategoryCreationForm.controls['minimumOrders'].enable();
    }

    public addPeriodicRequirement(): void{
        let fa = this.actionPointCategoryCreationForm.controls['periodRequirement'] as FormArray;
        const formGroup = new FormGroup({
            sequenceFrom: new FormControl(null, [Validators.required]),
            sequenceTo: new FormControl(null, [Validators.required]),
            minimum: new FormControl(null, [Validators.required, Validators.min(1)])
        })
        formGroup.setValidators([this.validateFidelityPeriod(), this.validateFidelityPeriodMinimum()])
        fa.push(formGroup)
    }

    public addPeriodicRequirementsEdit(fidelityData: FidelityActionPointDTO): void{
        let fa = this.actionPointCategoryCreationForm.controls['periodRequirement'] as FormArray;
        for(let period of fidelityData.periodRequirement){
            const formGroup = new FormGroup({
                sequenceFrom: new FormControl(period.sequenceFrom, [Validators.required]),
                sequenceTo: new FormControl(period.sequenceTo, [Validators.required]),
                minimum: new FormControl(period.minimum, [Validators.required, Validators.min(1)])
            })
            formGroup.setValidators([this.validateFidelityPeriod(), this.validateFidelityPeriodMinimum()])
            fa.push(formGroup)
        }

    }

    public deleteYear(index:number):void{
        this.getPeriodRequirement().removeAt(index);
        this.actionPointCategoryCreationForm.markAsUntouched();
        this.actionPointCategoryCreationForm.markAsTouched();
        this.actionPointCategoryCreationForm.updateValueAndValidity();
    }

    public getPeriodRequirement(): FormArray{
        return this.actionPointCategoryCreationForm.controls['periodRequirement'] as FormArray;
    }

    public loadCampaigns() : void {
        this.loading$.next(true)
        this.campaignService.getCampaigns().subscribe({
            next: (campaigns : CampaignDTO[]) => {
                this.campaigns=campaigns;
                this.loading$.next(false);
                this.cdr.detectChanges()
            },
            error: (_ : Error) => {
                this.loading$.next(false)
                this.cdr.detectChanges()
            }
        });
    }

    public filterToCampaigns(i: number) : CampaignDTO[] {

        if (this.getPeriodRequirement().controls[i].get('sequenceFrom') == null) {
            return this.campaigns.filter(campaign => campaign.sequence <= this.data.campaignSequence)
        } else {
            return this.campaigns.filter(campaign => campaign.sequence >= this.getPeriodRequirement().controls[i].get('sequenceFrom').value && campaign.sequence <= this.data.campaignSequence);
        }
    }

    public filterFromCampaigns() : CampaignDTO[] {
        return this.campaigns.filter(campaign => campaign.sequence <= this.data.campaignSequence)
    }
    /**
     * @description
     *	Convierte un string a un numero (para usar desde el html)
     *
     *  @param value - valor numerico como string
     *  @returns el valor como int
     */
    public getNumber(value: string): number{
        return parseInt(value);
    }

    /**
     * @description
     *	Se llama cuando se cambia el valor de campaignsToNet. Si expirationPointsCampaign tenia un valor
     *  que es menor al nuevo valor se hace un reset del campo.
     *
     *  @param newValue - el nuevo valor del campo campaignsToNet
     *  @param isIndicationForm - valor que indica cual de los formularios a utilizar
     *
     */
    public updateExpiration(newValue: number, isIndicationForm: boolean): void{
        if(!isIndicationForm){
            if(this.actionPointCategoryCreationForm.controls['expirationPointsCampaign'].value <= newValue )
                this.actionPointCategoryCreationForm.controls['expirationPointsCampaign'].reset()
        }
        else{
            if(this.indicationCategoryCreationForm.controls['expirationPointsCampaign'].value <= newValue )
                this.indicationCategoryCreationForm.controls['expirationPointsCampaign'].reset()
        }
    }


    /**
     * @description
     *	Validacion para Indicadores, valida que no se hayan deselecionado ambas opciones
     */
    private validateIndicator(): ValidatorFn {
        return (formGroup:FormGroup):{[key: string]: any} | null=>{
           let indicated = this.actionPointCategoryCreationForm.controls['indicator'].value;
           let indicator = this.indicationCategoryCreationForm.controls['indicated'].value;
           if(indicated || indicator)
             return null
           return {NonSelected:true}
        }
    }

    /**
     * @description
     *	Validacion para Fidelidad, valida que el campaign sequence del hasta no sea mas chico que el desde
     */
    private validateFidelityPeriod(): ValidatorFn {
        return (formGroup:FormGroup):{[key: string]: any} | null=>{
            let desde = formGroup.controls['sequenceFrom'].value;
            let hasta = formGroup.controls['sequenceTo'].value;
            if(desde < hasta) {
                formGroup.controls['sequenceTo'].setErrors(null)
                return null
            }
            formGroup.controls['sequenceTo'].setErrors({wrongPeriod:true})
            return {wrongPeriod:true}
        }

    }
    /**
     * @description
     *	Validacion para Fidelidad, valida que el minimo de pedidos no sea mayor a la cantidad de campañas en ese periodo
     */
    private validateFidelityPeriodMinimum(): ValidatorFn {
        return (formGroup:FormGroup):{[key: string]: any} | null=>{
            let from = formGroup.controls['sequenceFrom'].value;
            let to = formGroup.controls['sequenceTo'].value;
            let minimum = formGroup.controls['minimum'].value;
            let quantity = to - from + 1;
            if(minimum <= quantity || quantity <= 0) {
                formGroup.controls['minimum'].setErrors(null)
                return null
            }
            formGroup.controls['minimum'].setErrors({wrongAmount:true})
            return {wrongAmount:true}
        }

    }

    private getToolTip(source)
    {
        let tooltip = '';
        if(source==ActionPointType.Fidelity || source==ActionPointType.Continuity)
        {
          tooltip = 'Cuando cada revendedora cumpla con los requisitos del programa.';
        }
        else
        {
          tooltip = 'Cuando cada indicada cumplan con todos los requisitos del programa.';
        }
        return tooltip;
    }

    private getLabel(source)
    {
        let label = '';
        if(source==ActionPointType.Fidelity || source==ActionPointType.Continuity)
        {
            label = 'Puntos que recibe la revendedora';
        }
        else
        {
            label = 'Puntos que recibirá la indicante por cada indicada';
        }
        return label;
    }

}
